// Module
var code = "<h2 class=\"interiorSectionHeading\">Private Education Loan Forbearance Forms</h2> <p>Apply for a forbearance to temporarily reduce or postpone payments on your private education loans.</p> ";
// Exports
export default code;